import Alert from '@/components/UI/Alert'

export default function CollegeAlgebraWarning(): React.ReactElement {
  return (
    <Alert variant="info" mb="24px">
      Please note that the College Algebra course is different than Algebra 1 or Algebra 2. If you
      are trying to tutor in one of those subworlds, please return to the subworld and go to the
      Certify page there.
    </Alert>
  )
}
